<template>
  <div
    :class="[wrapperClasses, $attrs.class]"
    :style="$attrs.style"
  >
    <input
      v-bind="inputAttrs"
      :id="value"
      type="checkbox"
      :value="value"
      :checked="isChecked"
      @change="toggleCheck"
      class="input-checkbox__input form-check-input"
    >
    <label class="input-checkbox form-check-label"
      :for="value"
    >
      <slot/>
    </label>
  </div>
</template>

<script>
  export default {
    inheritAttrs: false,
    emits: ['update:modelValue', 'change'],
    props: {
      // String (e.g. 'checked') is allowed for truthy display parity with legacy call sites
      modelValue: {
        type: [Boolean, Array, String],
        default: undefined,
      },
      value: {
        type: [String, Number],
        default: null,
      },
      wrapperClasses: {
        type: String,
        default: 'input-wrapper form-check',
      },
    },
    computed: {
      isChecked() {
        if (Array.isArray(this.modelValue)) {
          return this.modelValue.includes(this.value);
        }
        return this.modelValue;
      },
      // Forward fallthrough attrs to the input only; class/style are bound on the wrapper above.
      // `class: _c` / `style: _s` strip those keys from $attrs; the values are unused on purpose.
      inputAttrs() {
        const { class: _c, style: _s, ...rest } = this.$attrs;
        return rest;
      },
    },
    methods: {
      toggleCheck(event) {
        let newChecked;
        if (Array.isArray(this.modelValue)) {
          newChecked = [...this.modelValue];
          const valueIndex = newChecked.indexOf(this.value);
          if (valueIndex === -1) {
            newChecked.push(this.value);
          } else {
            newChecked.splice(valueIndex, 1);
          }
        } else {
          newChecked = event.target.checked;
        }
        this.$emit('update:modelValue', newChecked);
        this.$emit('change', newChecked);
      },
    },
  };
</script>

<style lang="scss">
  @import "~styles/definitions";
</style>
